// Quem pode abrir cada rota (meta.roles). A sidebar só esconde
// o item; sem a guarda, a tela abria digitando a URL (a API recusa, mas a
// página aparecia vazia).
export const homeFor = profile => (profile === 'external' ? 'queue' : 'inbox')

// Retorna o redirect quando o acesso é negado; null quando pode entrar.
// Cada perfil volta pra própria tela inicial — terceiro barrado em 'inbox'
// não pode ser mandado pra 'inbox' de novo (loop).
export function deniedRedirect(meta, auth) {
  if (meta.roles && !meta.roles.includes(auth.profile)) return { name: homeFor(auth.profile) }
  return null
}
